import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';
import { IntegrityMonitorRulesSmartViewsDataProvider } from '../dataProvider/IntegrityMonitorRulesSmartViewsDataProvider';

export class IntegrityMonitorRulesSmartViewsDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorRulesSmartViewsDataProvider);
  }
}
